import type { Practice } from "services/types/clinics.type";

/**
 * Whether cancelling (or deleting) an appointment should ask staff "Send cancellation
 * message?". Only for a practice set to "Ask each time": the message must be on, and the
 * prompt field must exist — a backend that predates it returns no field, so nothing asks.
 */
export const asksCancellationMessage = (
  practice:
    | Pick<
        Practice,
        | "appointment_cancelled_message_disabled"
        | "appointment_cancelled_message_prompt"
      >
    | null
    | undefined
): boolean =>
  practice?.appointment_cancelled_message_prompt === true &&
  practice?.appointment_cancelled_message_disabled === false;

/**
 * The request-body key for the staff member's answer. Sent only when they were asked, so
 * a practice that never asks sends exactly what it sent before.
 */
export const cancellationMessageBody = (
  sendCancellationMessage: boolean | undefined
): { send_cancellation_message?: boolean } =>
  sendCancellationMessage === undefined
    ? {}
    : { send_cancellation_message: sendCancellationMessage };
